module.exports = __webpack_public_path__ + "static/primary-stacked-black-ccfb1697ec7c8f810914b37d0064cbd2.png";